// extracted by mini-css-extract-plugin
export default {"ac-collapsable-content":"ac-collapsable_ac-collapsable-content__JwFv2","ac-collapsable--collapsed":"ac-collapsable_ac-collapsable--collapsed__R8Kp1"};